import * as React from 'react';
import { useSelector } from 'react-redux';

import { currentOpenChatSelector, userIdSelector } from '../selectors';
import { EChatRole } from '../types/userData';
import { useApplicationContext } from '../utils/applicationContext';
import { sendUXSEvent } from '../utils/uxs';

// Отправляем опрос:
// если текущий пользователь является инициатором чата
// если в чате есть кнопка принятия предложения (actionButton)
// если текущий пользователь не нажал на кнопку принятия предложения

// на desktop отправляем в момент переключения на другой чат в списке чатов
// на mobile отправляем в момент нажатия "Назад" в шапке
export const useMailingUxfeedbackCampaign = () => {
  const currentChat = useSelector(currentOpenChatSelector);
  const userId = useSelector(userIdSelector);

  const { config } = useApplicationContext();

  const { users, chatMessages } = currentChat || {};

  const sendMailingUxfeedbackCampaign = React.useCallback(() => {
    const mailingUxfeedbackNames = config.get<string[]>('frontend-chats.mailingUxfeedbackNames') || [];
    const initiator = users?.find(user => user.chatRole === EChatRole.Initiator);

    if (userId !== initiator?.userId) {
      return;
    }

    if (!chatMessages || !chatMessages.length || !mailingUxfeedbackNames.length) {
      return;
    }

    const hasMailing = chatMessages
      .flatMap(chatMessage => chatMessage.message.actionButtonsV3 || [])
      .some(button => {
        const buttonName = button.analyticsName;

        return buttonName ? mailingUxfeedbackNames.includes(buttonName) : false;
      });

    if (hasMailing) {
      sendUXSEvent('mailing_survey_web');
    }
  }, [chatMessages, config, users, userId]);

  return { sendMailingUxfeedbackCampaign };
};
